import {
    formatNumberAbbreviated,
    tooltipRenderer,
} from '../сonfig-and-helpers/helpers';

function housingAffordabilityChartOptions() {
    return {
        container: document.querySelector('[data-page-chart]'),
        autoSize: true,
        navigator: {
            enabled: true,
        },
        data: [],
        title: {
            text: '',
            fontSize: 18,
            spacing: 25,
        },
        // series: [], is set dynamically
        axes: [
            {
                type: 'category',
                position: 'bottom',
            },
            {
                type: 'number',
                position: 'left',
                title: {},
                label: {
                    formatter: (params) => {
                        return String(formatNumberAbbreviated(params.value));
                    },
                },
            },
        ],
    };
}

export default housingAffordabilityChartOptions;
